import { ContentContainer } from "components/layout/Layout";
import * as React from "react";
import { FILES } from "i18n/constants";
import NextImage from "components/parts/NextImage";
import { getSecurityBadges } from "./utils";
import { SecurityGrid } from "./styles";
import { Flex, Text } from "@hubble/web";
import { useTranslations } from "i18n";

const Badges = () => {
  const t = useTranslations(FILES.COMMON);
  return (
    <ContentContainer>
      <SecurityGrid>
        <Flex
          flexWrap="wrap"
          gap="32px"
          css={{ "@media (max-width: 780px)": { alignItems: "center" } }}
        >
          {getSecurityBadges({ t }).map((badge, i) => (
            <Flex
              key={i}
              alignItems="center"
              css={{
                width: "30%",
                "@media (max-width: 780px)": {
                  width: "100%",
                  flexDirection: "column"
                }
              }}
            >
              <NextImage
                containerStyles={{ width: "max-content" }}
                alt={badge.iconAlt}
                src={badge.icon}
              />

              <Flex.Column
                ml={2}
                css={{
                  textAlign: "left",
                  "@media (max-width: 780px)": { textAlign: "center" }
                }}
              >
                <Text.Body size="sm" bold mb={0.5}>
                  {badge.title}
                </Text.Body>
                <Text.Body size="sm">{badge.text}</Text.Body>
              </Flex.Column>
            </Flex>
          ))}
        </Flex>
      </SecurityGrid>
    </ContentContainer>
  );
};
export default Badges;
